import React, { useEffect, useState } from "react";
import "./ViewDetailProduct.css";
import { useNavigate, useParams } from "react-router-dom";
import { cart, cartItem, product, store } from "../../utils/models";
import { getSessionStorage, setSessionStorage } from "../../utils/helper";
import { useApiServices } from "../../services/endpoints/ApiEndpoint";
import { useDispatch } from "react-redux";
import { addToCart } from "../../redux/actions/cartSlice";
import { toast } from "react-toastify";
import Image from "../../components/image/Image";
import { useAlert } from "../../components/alert-context/AlertContext";
import Button from "../../components/button/Button";

const ViewDetail: React.FC = () => {
  const alert = useAlert();
  const { GetProductsAsync } = useApiServices()
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const { id, gid } = useParams();
  const [numberProducts, setNumberProducts] = useState<number>(1);
  const [selectionIndex, setSelectionIndex] = useState<number>(0)
  const [detail, setDetail] = useState<product>()
  const [pricing, setPricing] = useState<any>({})
  const [stores, setStores] = useState<any[]>([])
  const [selectedProduct, setSelectedProduct] = useState<any>(null)
  const [note, setNote] = useState<string>('')
  const addToCart1 = () => {
    const cartStore: store = {
      id: stores[selectionIndex].storeId,
      name: stores[selectionIndex].storeName,
      items: [
        {
          productId: id as string,
          quantity: numberProducts,
          product: detail,
          price: stores[selectionIndex].price as number,
          ...(note.trim() ? { note: note.trim() } : {}),
        }
      ]
    }
    dispatch(addToCart(cartStore))
    // toast.success(`Added to cart`)
    alert.confirm({
      message: `เพิ่มสินค้า ${detail?.nameTh} ไปยังรถเข็นเรียบร้อยแล้ว`, confirmText: 'ไปยังรถเข็น', onConfirm: () => {
        navigate('/cart')
      }, cancelText: 'เลือกสินค้าต่อ', onCancel: () => {
        navigate('/')
      }
    })
  };

  const increaseNumber = () => {
    setNumberProducts((prevNumber) =>
      prevNumber < 999 ? prevNumber + 1 : 999
    );
  };

  const decreaseNumber = () => {
    setNumberProducts((prevNumber) => (prevNumber > 1 ? prevNumber - 1 : 1));
  };

  const fetchProductDetail = async (id: string) => {
    var { result } = await GetProductsAsync(id);
    setDetail(result)
    console.log('detail', result);

  }

  useEffect(() => {
    console.log('id', id);
    console.log('gId', gid);

    if (gid) {
      //have group id
      const p = getSessionStorage('pricing')
      const group = p.find((x: any) => x.productGroupId == gid)
      setPricing(group)
      console.log('group', group);
      if (id) {
        fetchProductDetail(id)
        setSelectedProduct(id)
        setStores(group.products.find((x: any) => x.productId == id)?.stores || [])
      } else {
        setSelectedProduct(group.products[0]?.productId)
        setStores(group.products[0]?.stores || [])
      }
      // setPricing(p.find((x: any) => x.productGroupId == gid))
    } else if (id) {
      fetchProductDetail(id)
      let p = getSessionStorage('pricing')
      console.log('product', p);

      setStores(p.find((x: any) => x.productId == id)?.stores || [])
    }
  }, [id, gid])

  return (
    <section className="vd-wrapper">
      <div className="vd-container lg:container lg:mx-auto">

        {/* Header */}
        <div className="vd-header">
          <h2 className="vd-title">รายละเอียดสินค้า</h2>
        </div>

        {/* Product card */}
        <div className="vd-product-card">
          <div className="vd-image-wrap">
            <Image id={detail?.image || ''} alt="product" className="w-full h-full object-cover" />
          </div>
          <div className="vd-body">
            <h2 className="vd-product-name">
              {pricing.productGroupName || pricing.productName || detail?.nameTh}
            </h2>

            {/* Product variants */}
            {gid && (
              <div className="vd-section">
                <h3 className="vd-section-title">ตัวเลือกสินค้า</h3>
                <div className="vd-options">
                  {pricing?.products?.map((p: any, index: number) => (
                    <label
                      key={`product-${index}`}
                      className={`vd-option ${p.productId == selectedProduct ? 'vd-option--selected' : ''}`}
                    >
                      <input
                        type="radio"
                        name="radio-1"
                        className="vd-radio"
                        value={p.productId}
                        checked={p.productId == selectedProduct}
                        onChange={() => {
                          setSelectedProduct(p.productId)
                          setStores(p.stores || [])
                          setSelectionIndex(0)
                        }}
                      />
                      <span className="vd-option-label">{p.productName}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}

            {/* Store selection */}
            <div className="vd-section">
              <h3 className="vd-section-title">เลือกร้าน</h3>
              <div className="vd-options">
                {stores?.map((p: any, index: number) => (
                  <label
                    key={`store-${index}`}
                    className={`vd-option ${selectionIndex === index ? 'vd-option--selected' : ''}`}
                  >
                    <input
                      type="radio"
                      name="radio-10"
                      className="vd-radio"
                      value={index}
                      checked={selectionIndex === index}
                      onChange={() => setSelectionIndex(index)}
                    />
                    <span className="vd-option-label">{p.storeName}</span>
                    <span className="vd-option-price">{p.price?.toLocaleString()} บาท</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Quantity */}
            <div className="vd-section">
              <h3 className="vd-section-title">จำนวน</h3>
              <div className="vd-stepper">
                <button className="vd-stepper-btn" onClick={decreaseNumber}>−</button>
                <input
                  type="number"
                  className="vd-stepper-input"
                  value={numberProducts}
                  onChange={(e) =>
                    setNumberProducts(Math.min(parseInt(e.target.value, 10) || 1, 999))
                  }
                />
                <button className="vd-stepper-btn" onClick={increaseNumber}>+</button>
              </div>
            </div>

            {/* Add to cart */}
            <div className="vd-cart-action">
              <Button onClick={addToCart1} variant="primary" fullWidth>เพิ่มไปยังตะกร้า</Button>
            </div>
          </div>
        </div>

        {/* Notes */}
        {/* <div className="vd-section-label">หมายเหตุ</div>
        <div className="vd-notes-card">
          <textarea
            className="vd-textarea"
            placeholder="หมายเหตุ"
            value={note}
            onChange={e => setNote(e.target.value)}
          />
        </div> */}

        {/* Key Highlight */}
        {detail?.descriptionTh && (
          <>
            <div className="vd-section-label">รายละเอียดสินค้า</div>
            <div className="vd-highlight-card">
              <p className="vd-highlight-text">{detail.descriptionTh}</p>
            </div>
          </>
        )}

        {/* Back */}
        <div className="vd-actions">
          <Button variant="secondary" onClick={() => navigate("/")}>ย้อนกลับ</Button>
        </div>

      </div>
    </section>
  );
};

export default ViewDetail;
